import * as linkify from 'linkifyjs';

export function extractLinksFromString(text: string): Array<string> {
  return linkify.find(text, 'url').map((link) => link.href);
}

export function extractDomainName(url: string) {
  return url ? new URL(url).hostname : '';
}
